import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AlarmClock, ChevronRight } from "lucide-react";
import { api } from "@/api/client";
import { urgency } from "@/pages/Requirements";

export function UrgentRequirementsTile() {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/pipeline/requirements").then(({ data }) => setItems(data)).catch(() => setItems([])); }, []);
  const flagged = (items || []).map(urgency).filter(Boolean);
  const overdue = flagged.filter((u) => u.label === "Overdue").length;
  const urgent = flagged.length - overdue;
  return (
    <Link to="/requirements?filter=urgent" className="block lg:col-span-3 bg-white border border-orange-200 rounded-xl p-5 hover:border-orange-400 hover:shadow-sm transition-[border-color,box-shadow]" data-testid="urgent-requirements-tile">
      <div className="flex items-center justify-between gap-3">
        <div className="flex items-center gap-2 text-sm font-semibold text-slate-800"><AlarmClock className="w-4 h-4 text-orange-600" /> Urgent crew requirements</div>
        <ChevronRight className="w-4 h-4 text-slate-400" />
      </div>
      {items === null ? <div className="text-sm text-slate-400 mt-3">Loading…</div> : (
        <div className="mt-3 flex flex-wrap gap-6">
          <div><div className="text-3xl font-bold text-orange-600" data-testid="urgent-count">{urgent}</div><div className="text-xs text-slate-500">Urgent · joining within 14 days</div></div>
          <div><div className="text-3xl font-bold text-rose-600" data-testid="overdue-count">{overdue}</div><div className="text-xs text-slate-500">Overdue · joining date passed, still open</div></div>
        </div>
      )}
      <div className="text-xs text-orange-700 mt-3">View urgent &amp; overdue slots →</div>
    </Link>
  );
}
